import 'arrive';
import Swiper from 'swiper/bundle';

document.arrive('.block-post-call', { existing: true }, function (el) {
    const container = el.querySelector('.block-post-call__grid.swiper');
    if (!container || container.dataset.swiperInitialized === 'true') return;

    // Mark as initialized to avoid duplicates
    container.dataset.swiperInitialized = 'true';

    const slides = container.querySelectorAll('.swiper-wrapper > .swiper-slide');
    const slideCount = slides.length;
    if (slideCount < 3) return;

    const hasPagination = container.dataset.pagination === 'true';
    const paginationEl = hasPagination ? container.querySelector('.swiper-pagination') : null;


    function clamp(min, val, max) {
        return Math.min(Math.max(val, min), max);
    }
    
    function getSwiperGap() {
        return clamp(20, window.innerWidth * 0.0167, 32); 
    }

    // On mobile, turn grid into slider with 1.2 slides per view and no effect
    const swiper = new Swiper(container, {
        slidesPerView: 1.15,
        spaceBetween: getSwiperGap(),
        loop: false,
        freeMode: true,
        allowTouchMove: true,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        breakpoints: {
            1080: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2.8,
            },
            600: {
                slidesPerView: 2.5,
            },
            550: {
                slidesPerView: 1.2,
            },
        },
    });

    // aggiorna il gap al resize
    window.addEventListener('resize', () => {
        swiper.params.spaceBetween = getSwiperGap();
        swiper.update();
    });
});